import React, { useState } from 'react'
import { Button, Typography, Popover } from '@telavita-core/react-design-kit'
import { format } from 'date-fns'

import { WeeklyCalendar } from 'components/WeeklyCalendar'

import { ReactComponent as ArrowDownIcon } from 'static/svg/icon_arrow-down.svg'
import { ReactComponent as ArrowUpIcon } from 'static/svg/icon_arrow-up.svg'

import * as S from './styles'

interface SelectAvailableDateOnWeeklyCalendarProps {
  selectedDate: Date
  onSetSelectedDate: (date: Date) => void
}

const formatDate = (date: Date) => {
  if (!date) return null
  
  return format(date, 'dd/MM')
}

const ArrowIcon = ({ isOpen }) => isOpen ? <ArrowUpIcon /> : <ArrowDownIcon />

export const SelectAvailableDateOnWeeklyCalendar: React.FC<SelectAvailableDateOnWeeklyCalendarProps> = ({ selectedDate, onSetSelectedDate }) => {
  const [openWeeklyCalendar, setOpenWeeklyCalendar] = useState(false)
  
  const closeShortCalendar = () => {
    setOpenWeeklyCalendar(false)
  }

  const handleDateChange = (date: Date) => {
    onSetSelectedDate(date)
    closeShortCalendar()
  }

  const toggleWeeklyCalendar = () => {
    if (selectedDate) {
      setOpenWeeklyCalendar((isOpen) => !isOpen)
    }
  }

  const content = (
    <WeeklyCalendar
      initialDate={selectedDate}
      handleDateChange={handleDateChange}
    />
  )

  return (
    <S.PopoverWrapper>
      <Popover
        content={content}
        onClickOutside={closeShortCalendar}
        visible={openWeeklyCalendar}
        placement='bottom-start'
      >
        <S.Wrapper isWeeklyCalendarOpen={openWeeklyCalendar}>
          <Button onClick={toggleWeeklyCalendar}>
            <Typography 
              variant='content2' 
              weight='bold' 
              customClassName='DatePickerText' 
            >
              {formatDate(selectedDate) || '--/--'}
            </Typography>
            <ArrowIcon isOpen={openWeeklyCalendar} />
          </Button>
        </S.Wrapper>
      </Popover>
    </S.PopoverWrapper>
  )
}